import type { Granularity } from "app/pages/activation-alerts/types/PlatformAlerts";
import { GranularityNames } from "app/UtilitiesAndConstants/Constants/Moment";
import { ActivationSubscriptions } from "app/pages/activation/components/Shared/Subscriptions/types";

import { BenchmarkGranularity } from "../../types/common";

export enum SubscriptionActions {
    SetGranularity = "SetGranularity",
    SetSwitch = "SetSwitch",
}

type StateValueSchema = { default: boolean | Granularity; current: boolean | Granularity };

type SubscriptionPayload = {
    subscriptionName: ActivationSubscriptions;
    value: StateValueSchema;
};

export type SubscriptionStateSchema = {
    switch: Record<ActivationSubscriptions, { default: boolean; current: boolean }>;
    granularity: Record<
        ActivationSubscriptions.BenchmarkDigest | ActivationSubscriptions.CompetitorsAlerts,
        { default: BenchmarkGranularity; current: BenchmarkGranularity }
    > & {
        [ActivationSubscriptions.NewsAlerts]: { default: Granularity; current: Granularity };
    };
};

export const initialState: SubscriptionStateSchema = {
    switch: {
        [ActivationSubscriptions.BenchmarkDigest]: { default: false, current: false },
        [ActivationSubscriptions.CompetitorsAlerts]: { default: false, current: false },
        [ActivationSubscriptions.NewsAlerts]: { default: false, current: false },
    },
    granularity: {
        [ActivationSubscriptions.BenchmarkDigest]: {
            default: BenchmarkGranularity.WEEKLY,
            current: BenchmarkGranularity.WEEKLY,
        },
        [ActivationSubscriptions.CompetitorsAlerts]: {
            default: BenchmarkGranularity.WEEKLY,
            current: BenchmarkGranularity.WEEKLY,
        },
        [ActivationSubscriptions.NewsAlerts]: {
            default: GranularityNames.DAILY,
            current: GranularityNames.DAILY,
        },
    },
};

export const reducerFn = (
    state: SubscriptionStateSchema,
    {
        type,
        payload,
    }: {
        type: SubscriptionActions;
        payload: SubscriptionPayload;
    },
) => {
    switch (type) {
        case SubscriptionActions.SetGranularity:
            return {
                ...state,
                granularity: {
                    ...state.granularity,
                    [payload.subscriptionName]: payload.value,
                },
            };
        case SubscriptionActions.SetSwitch:
            return {
                ...state,
                switch: {
                    ...state.switch,
                    [payload.subscriptionName]: payload.value,
                },
            };
        default:
            break;
    }
};
